import { Divider, Paper, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { REPORT_CHART_FONT } from './chart-theme';

const FONT_SX = { fontFamily: REPORT_CHART_FONT.family, color: REPORT_CHART_FONT.color };

type ReportChartTooltipFrameProps = {
  title: ReactNode;
  children: ReactNode;
};

export const ReportChartTooltipFrame: React.FC<ReportChartTooltipFrameProps> = ({ title, children }) => (
  <Paper elevation={3} sx={{ borderRadius: 1.5, minWidth: 190, py: 0.75 }}>
    <Typography sx={{ ...FONT_SX, fontSize: 11, fontWeight: 600, px: 1.5, pb: 0.5 }}>
      {title}
    </Typography>
    <Divider />
    <Stack sx={{
      pt: 0.5
    }}>{children}</Stack>
  </Paper>
);

type ReportChartTooltipRowProps = {
  color: string;
  label: string;
  formattedValue: string;
};

export const ReportChartTooltipRow: React.FC<ReportChartTooltipRowProps> = ({
  color,
  label,
  formattedValue,
}) => (
  <Stack
    direction="row"
    sx={{
      alignItems: "center",
      gap: 0.75,
      py: 0.25,
      px: 1.5
    }}>
    <div
      style={{
        backgroundColor: color,
        width: 8,
        height: 8,
        borderRadius: '2px',
        flexShrink: 0,
      }}
    />
    <Typography sx={{ ...FONT_SX, fontSize: 11, color: 'text.secondary', minWidth: 70 }}>
      {label}
    </Typography>
    <Typography sx={{ ...FONT_SX, fontSize: 11, fontWeight: 600, color: 'text.primary', ml: 'auto' }}>
      {formattedValue}
    </Typography>
  </Stack>
);
